import React, { useState } from 'react';
import { iphoneRedeemCode, iphoneGolfStore } from '../link-actions';
import LogoText from '../components/logoText';
import PillToggle from '../components/pillToggle';

function formatExpiry(date) {
    return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

function PromoMidSection(props) {
    let promo = props.promo;
    const [showYearly, setShowYearly] = useState(true);
    const plan = showYearly ? promo?.yearly : promo?.monthly;

    return (<div className="row justify-content-center clearfix mt-3">
                    <div className="col-lg-6 col-12 text-center align-self-center p-2">
                        { promo ? <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 10px 0'}}>{promo.name}</h4>
                            <PillToggle offLabel="Monthly" onLabel="Yearly" initialValue={showYearly} onChange={(isYearly) => { setShowYearly(isYearly); window.gtag('event', 'plan_period_toggle', { plan_period: isYearly ? 'yearly' : 'monthly' }); }} />
                            <div style={{ fontSize: '22px', marginTop: '10px', lineHeight: "1.3", color: "white" }}>{plan.description}</div>
                            <div style={{ fontSize: '18px', lineHeight: "1.5", color: "var(--thm-black)", marginTop: '5px', marginBottom:'0px' }}>(Normally {plan.normalPrice})</div>
                            <button className="href-button" onClick={() => iphoneRedeemCode(plan.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></button>
                            <div style={{ fontSize: '16px', lineHeight: "1.3", color: "white", marginBottom:'2px' }}>Offer ends {formatExpiry(promo.expires)}</div>
                            <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.</div>
                        </div> :
                        <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                            <h4 className="heading-size" style={{ color: "white", margin:'15px 0 0px 0'}}>Try free for 7 days</h4>

                            <button className="href-button" onClick={() => iphoneGolfStore("golf")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></button>
                            <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom: '10px' }}>Cancel any time</div>

                        </div>
}
                    </div>
                </div>
    );
}

function PromoBestWayToTry(props) {
    let promo = props.promo;
    const [showYearly, setShowYearly] = useState(true);
    const plan = showYearly ? promo?.yearly : promo?.monthly;

    if(promo) {
return (<div className="row justify-content-center clearfix" style={{ background: 'url(./assets/img/smokebg_dark_compressed.jpg)',  marginTop: '30px', padding: '25px 5px'}}>
                  <div className="col-12 text-center" style={{padding:"20px"}}>
                      <h2 className="heading-size" style={{ margin: "0", color: 'yellowgreen' }}>The best way to try...</h2>
                      <div style={{color:'white', fontSize:'20px', fontWeight:"normal", lineHeight:'2rem', marginBottom: '20px', marginTop: '5px'}}>is with our {promo.name}</div>
                      <PillToggle offLabel="Monthly" onLabel="Yearly" initialValue={showYearly} onChange={(isYearly) => { setShowYearly(isYearly); window.gtag('event', 'plan_period_toggle', { plan_period: isYearly ? 'yearly' : 'monthly' }); }} />
                      <div style={{ fontSize: '20px', marginTop: '10px', lineHeight: "1.3", color: "white" }}>{plan.description}</div>
                        <div style={{ fontSize: '18px', lineHeight: "1.5", color: "yellowgreen", marginTop: '5px', marginBottom:'0px' }}>(Normally {plan.normalPrice})</div>
                        <button className="href-button" onClick={() => iphoneRedeemCode(plan.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></button>
                        <div style={{ fontSize: '16px', lineHeight: "1.3", color: "white", marginBottom:'2px' }}>Offer ends {formatExpiry(promo.expires)}</div>
                        <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.</div>
                  </div>
              </div>
    );
    } else {
        return <></>
    }

}

function PromoHeading(props) {
    let promo = props.promo;
    let monthly = promo?.monthly;
    let yearly = promo?.yearly;
    const [showYearly, setShowYearly] = useState(true);
    const plan = showYearly ? yearly : monthly;

    return (<>
    {promo ? <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                <h2 className="heading-size" style={{ fontFamily: "Bebas Neue", color: "white", margin:'15px 0 10px 0'}}>{promo.name}</h2>
                <PillToggle offLabel="Monthly" onLabel="Yearly" initialValue={showYearly} onChange={(isYearly) => { setShowYearly(isYearly); window.gtag('event', 'plan_period_toggle', { plan_period: isYearly ? 'yearly' : 'monthly' }); }} />
                <div>
                    <div style={{ fontSize: '22px', marginTop: '10px', lineHeight: "1.3", color: "white" }}>{plan.description}</div>
                    <div style={{ fontSize: '16px', lineHeight: "1.5", color: "var(--thm-black)", marginTop: '5px', marginBottom:'0px' }}>(Normally {plan.normalPrice})</div>
                    <button className="href-button" onClick={() => iphoneRedeemCode(plan.code)} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></button>
                </div>
                    <div style={{ fontSize: '16px', lineHeight: "1.3", color: "white", marginBottom:'2px' }}>Offer ends {formatExpiry(promo.expires)}</div>
                    <div style={{ fontSize: '12px', lineHeight: "1.3", color: "white", marginBottom:'10px' }}>*USD. Prices vary per region. Cancel any time.</div>

            </div> :
            <div className="text-center align-self-center p-1" style={{backgroundColor: 'yellowgreen', borderRadius: '10px'}}>
                <h4 className="heading-size" style={{ color: "white", margin:'15px 0 0px 0'}}>Try free for 7 days</h4>
                
                <button className="href-button" onClick={() => iphoneGolfStore("golf")} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></button>
                <div style={{ fontSize: '14px', lineHeight: "1.3", color: "white", marginBottom: '10px' }}>Cancel any time</div>
                    
            </div>
            }</>
)
}

export {PromoMidSection, PromoBestWayToTry, PromoHeading};

